export default __webpack_public_path__ + "static/media/DisableUpload.77639378.svg";